import React from 'react';
import ReactDOM from 'react-dom/client';

// IMPORTANT: Import Amplify config first, before any component that uses auth
import './config/amplify';

import './index.css';
import App from './App';
// Doit être importé avant le rendu : configure la langue et charge les dictionnaires.
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
